import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateUserMutation } from '../../features/fullApi';

export default function EditDialog({openEdit, setOpenEdit, handleUpdateUser, item}) {


    console.log("####INSIDE EDIT DIALOG####", item)

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateUser] = useUpdateUserMutation()


    const onSubmit = async(values, actions) => {
        console.log("Called on submit", values)
          updateUser({_id: item._id, username: values.username, email: values.email }, { 
          headers: {
              'Token': `Bearer ${user?.accessToken}`
          }
          }, {id: item._id})
          .then(res => {
            console.log("res is",res)
          })
          .catch((e) => {
          console.log("e is", e)
          })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          username: item?.username,
          email: item?.email,
        },
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} style={{width: '500px'}}>
            <Dialog fullWidth aria-labelledby='dialog-title' onClose={() => setOpenEdit(false)} open={openEdit}>
                <DialogTitle id='dialog-title'>
                    Edit User {item.username}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        id="username"
                        type="text"
                        margin="dense"
                        fullWidth
                        value={values.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.username ? "" : "username"}
                    />
                    {errors.username && touched.username && (
                        <p className="error">{errors.username}</p>
                    )}
                </DialogContent>
                <DialogContent>
                    <TextField
                        id="email"
                        type="text"
                        margin="dense"
                        fullWidth
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.email ? "" : "email"}
                    />
                    {errors.email && touched.email && (
                        <p className="error">{errors.email}</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        type="submit"
                        onClick={() => handleUpdateUser({id: item._id, username: values.username, email: values.email})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}